/**
 * Created by robert.lavoie on 7/26/17.
 */

// Modules
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Components
import { ModalComponent } from '../../components';

// Directives
import { OnHoverDarken } from '../../directives';

// Pipes
import { FontNamePipe, SafePipe } from '../../pipes';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        ModalComponent,
        OnHoverDarken,
        SafePipe,
        FontNamePipe,
    ],
    exports: [
        ModalComponent,
        OnHoverDarken,
        SafePipe,
        FontNamePipe,
    ]
})
export class AppModule {}